import { Divider, Typography } from '@mui/material';
import { Fragment } from 'react';

import { ModalNew } from '@hapvida/hapvida-core-components';

import type { ServiceModalProps } from './types';
import { ModalDescription, ModalTitle, TitleBox } from './styles';
import { RedirectItem } from './components';

export function ServiceModal({
  openModal,
  title,
  redirects,
  handleCloseModal,
}: Readonly<ServiceModalProps>) {
  return (
    <ModalNew.Container open={openModal} handleCloseModal={handleCloseModal}>
      <TitleBox>
        <ModalTitle>Selecione uma das opções para continuar</ModalTitle>
        <ModalDescription>
          <Typography variant="body2" component="span">
            Selecione uma das opções abaixo para continuar com{' '}
          </Typography>
          <Typography variant="body2" fontWeight={700} component="span">
            {title}
          </Typography>
        </ModalDescription>
      </TitleBox>
      <Divider />
      {redirects?.map(item => (
        <Fragment key={item.id}>
          <RedirectItem
            title={item.title}
            description={item.description}
            id={item.id}
            handleCloseModal={handleCloseModal}
          />
          <Divider />
        </Fragment>
      ))}
      <ModalNew.Footer
        secondaryButtonProps={{
          children: 'Fechar',
          onClick: handleCloseModal,
        }}
      />
    </ModalNew.Container>
  );
}
